import React, { useEffect } from 'react';
import { ToastProvider } from 'js/design_system/toasts/ToastProvider';
import { useToast } from 'js/design_system/toasts/hooks';
import { renderPaperClaimedToast } from './PaperClaimedToast';

const SESSION_KEY = 'kii_matching_claimed_count';

const PostClaimToastInner: React.FC = () => {
  const { toast } = useToast();

  useEffect(() => {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return;

    sessionStorage.removeItem(SESSION_KEY);
    const claimedCount = parseInt(raw, 10);
    if (!claimedCount) return;

    toast({
      render: renderPaperClaimedToast(claimedCount, {
        description:
          'These papers are now on your profile and Mentions will be more accurate.',
        showProfileLink: false,
      }),
      placement: 'bottom-end',
      closeable: true,
    });
  }, [toast]);

  return null;
};

export const MentionsPostClaimToast: React.FC = () => (
  <ToastProvider>
    <PostClaimToastInner />
  </ToastProvider>
);

export default MentionsPostClaimToast;
